<dw-ui-panel [defaultOpenedPanel]="infoPanel" [triggers]="triggers()">
  <dw-grid-detail-navigation
    header-actions
    [context]="[
      GoliathDocumentEntityNames.CustomerProject.shortName,
      GoliathDocumentEntityNames.CustomerDoc.shortName,
    ]"
  >
  </dw-grid-detail-navigation>
  <dw-grid-tabs>
    <div class="tabs">
      <ul
        ngbNav
        #nav="ngbNav"
        (navChange)="onTabChanged($event.nextId)"
        class="nav-underline nav-tabs d-flex border-0 me-md-auto"
      >
        <li [ngbNavItem]="'general'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-alert-info me-2 text-primary"></i>{{ '::General' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <div class="mt-2 container-panel">
                <form
                  id="generalForm"
                  [formGroup]="form"
                  [DwKeyboardShortcut]="shortcut.controlS"
                  (shortcutAction)="save()"
                >
                  <div class="card-group mb-3 mt-2 header">
                    <div class="card">
                      <div class="d-flex flex-column gap-2 h-100">
                        <div class="row row-cols-md-12">
                          <div class="col-md-12 p-0">
                            <label
                              for="companySiteId"
                              class="form-label text-primary"
                              dwInputRequired
                            >
                              {{ '::Site' | abpLocalization }}
                            </label>
                            <ng-select
                              class="form-control"
                              id="companySiteId"
                              bindLabel="code"
                              bindValue="id"
                              formControlName="companySiteId"
                              [loading]="companySiteStore.loading()"
                              [items]="companySiteStore.entities()"
                            >
                            </ng-select>
                          </div>
                        </div>

                        <div class="row row-cols-md-12">
                          <div class="col-md-12 p-0" [dwReadonlyForm]="this.entity?.id != null">
                            <label for="dayBookId" class="form-label text-primary" dwInputRequired>
                              {{ 'Doc::DayBook' | abpLocalization }}
                            </label>
                            <ng-select
                              class="form-control"
                              id="dayBookId"
                              formControlName="dayBookId"
                              bindLabel="name.current"
                              bindValue="id"
                              [items]="dayBooks$ | async"
                            >
                            </ng-select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <document-customer-date-card
                      [form]="form"
                      class="card"
                    ></document-customer-date-card>

                    <div class="card">
                      <div class="d-flex flex-column gap-2 h-100">
                        <div class="row row-cols-md-12">
                          <div class="col-md-12 p-0">
                            <label
                              for="thirdPartyId"
                              class="form-label text-primary"
                              dwInputRequired
                            >
                              {{ '::Customer' | abpLocalization }}
                            </label>
                            <ng-select
                              class="form-control"
                              id="thirdPartyId"
                              formControlName="thirdPartyId"
                              bindLabel="name"
                              bindValue="id"
                              [dwApiSelect]="thirdPartySelect"
                              #thirdPartySelectRef
                              #thirdPartySelectDirective="dwApiSelect"
                              [bufferAmount]="50"
                            >
                              <ng-template ng-label-tmp let-item="item">
                                @if (item.thirdPartyRole == thirdPartyRole.Customer) {
                                  <i class="digi-out-user-client text-primary"></i>
                                } @else if (item.thirdPartyRole == thirdPartyRole.Lead) {
                                  <i class="digi-out-contact text-dark"></i>
                                }
                                <span class="mx-1" [title]="item.name">
                                  {{ item.name }} [{{ item.code }}]</span
                                >
                              </ng-template>
                              <ng-template
                                ng-option-tmp
                                let-item="item"
                                let-index="index"
                                let-search="searchTerm"
                              >
                                @if (item.thirdPartyRole == thirdPartyRole.Customer) {
                                  <i class="digi-out-user-client text-primary"></i>
                                } @else if (item.thirdPartyRole == thirdPartyRole.Lead) {
                                  <i class="digi-out-contact text-dark"></i>
                                }
                                <span class="mx-1" [title]="item.name"
                                  >{{ item.name }} [{{ item.code }}]</span
                                >
                              </ng-template>
                              <ng-template ng-footer-tmp>
                                <button
                                  class="btn btn-primary"
                                  (click)="openModelThirdPartyForm(); thirdPartySelectRef.close()"
                                >
                                  {{ '::Add' | abpLocalization }}
                                </button>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>

                        <div class="row row-cols-md-12">
                          <div class="col-md-12 p-0">
                            <label for="reference" class="form-label text-primary">
                              {{ 'Doc::CustomerReference' | abpLocalization }}
                            </label>
                            <input type="text" class="form-control" formControlName="reference" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card card-single">
                      <div class="d-flex flex-column gap-2 h-100">
                        <div class="row row-cols-md-12">
                          <div class="col-md-12 p-0">
                            <label
                              for="salesPersonId"
                              class="form-label text-primary"
                              dwInputRequired
                            >
                              {{ '::Responsible' | abpLocalization }}
                            </label>
                            <ng-select
                              class="form-control"
                              id="salesPersonId"
                              formControlName="salesPersonId"
                              bindValue="id"
                              [loading]="salesPersonStore.loading()"
                              [items]="this.salesPersonStore.internalSalesPersons()"
                            >
                              <ng-template ng-label-tmp let-item="item">
                                @if (item != null) {
                                  @if (item.lastName != null) {
                                    {{ item.lastName }} {{ item.firstName ?? '' }}
                                  } @else {
                                    {{ item.code }}
                                  }
                                }
                              </ng-template>
                              <ng-template
                                ng-option-tmp
                                let-item="item"
                                let-index="index"
                                let-search="searchTerm"
                              >
                                <span [title]="item.firstName + ' ' + item.lastName">
                                  @if (item != null) {
                                    @if (item.lastName != null) {
                                      {{ item.lastName }} {{ item.firstName ?? '' }}
                                    } @else {
                                      {{ item.code }}
                                    }
                                  }
                                </span>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="row row-cols-md-12">
                          <div class="col-md-12 p-0">
                            <label
                              for="projectStatus"
                              class="form-label text-primary"
                              dwInputRequired
                            >
                              {{ 'Doc::ProjectStatus' | abpLocalization }}
                            </label>
                            <ng-select
                              class="form-control"
                              id="projectStatus"
                              formControlName="projectStatus"
                              bindLabel="name.current"
                              bindValue="id"
                              [loading]="enumerationTypeStore.loading()"
                              [items]="enumerationTypeStore.projectStatus()"
                            >
                            </ng-select>
                          </div>
                        </div>
                        <div class="row row-cols-md-12">
                          <div class="col-md-12 p-0">
                            <label for="description" class="form-label text-primary">
                              {{ '::Description' | abpLocalization }}
                            </label>
                            <input type="text" class="form-control" formControlName="description" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  @if (entity?.id != null && hierarchies.length > 0) {
                    <div>
                      <button
                        type="button"
                        class="show-more-btn btn btn-primary"
                        (click)="openGlobalView()"
                      >
                        <i class="digi-out-expand-ag pe-1"> </i
                        >{{ 'Doc::CustomerProject:ViewMore' | abpLocalization }}
                      </button>
                    </div>
                    <div class="card-group mb-2 mt-2 header">
                      <div class="card">
                        <div class="container hierarchy">
                          @for (
                            hierarchy of hierarchies.slice().reverse();
                            let i = $index;
                            track hierarchy
                          ) {
                            <div class="row-item">
                              <div>{{ hierarchy.documentDate }}</div>
                              <div>
                                @if (hierarchy.isClosedGlobal) {
                                  {{ 'Doc::CustomerProject:Closed' | abpLocalization }}
                                } @else if (hierarchy.statusGlobalId != null) {
                                  {{ getStatus(hierarchy.statusGlobalId, hierarchy.docRole) }}
                                } @else {
                                  {{ 'Doc::CustomerProject:InProgress' | abpLocalization }}
                                }
                              </div>
                              <div class="last-child">
                                <document-customer-project-hierarchy [hierarchyInput]="hierarchy">
                                </document-customer-project-hierarchy>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  @if (entity?.id) {
                    <div ngbScrollSpyFragment="products" dwScrollSpyItem [fragment]="'products'">
                      <document-customer-project-lines-grid
                        #projectLineGrid
                        [customerProject]="entity"
                        [readonly]="isClosed()"
                        [thirdPartyVatSystem]="thirdParty?.vatSystem"
                        (lineUpdatedEvent)="refreshAfterLineUpdate($event)"
                        (linePricingDetailsEvent)="updatePricingDetails($event)"
                      ></document-customer-project-lines-grid>
                    </div>
                  }
                </form>
              </div>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="'addresses'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-pin me-2 text-primary"></i
            >{{ 'Doc::CustomerQuote:Addresses' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <document-doc-customer-addresses
                class="d-block"
                [docForm]="form"
                [deliveryAddresses$]="thirdPartyDeliveryAddresses$"
                [invoicingAddresses$]="thirdPartyInvoicingAddress$"
                [pointOfSales$]="pointOfSales$"
                [workingSites$]="workingSites$"
                [docRoleInput]="docRole"
                [IsWebOrigin]="form.get('docOriginId').value == docOrigin.Web"
                (workingSiteSelected)="onWorkingSiteChanged($event)"
                (pointOfSaleSelected)="onPointOfSaleChanged($event)"
              ></document-doc-customer-addresses>
            </div>
          </ng-template>
        </li>

        <li [ngbNavItem]="'crm'" [disabled]="!entity?.id">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-folder-links me-2"></i>{{ 'Doc::Activities' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <contact-customer-project-activity
                [customerProjectId]="entity?.id"
                [thirdPartyId]="entity?.thirdPartyId"
              ></contact-customer-project-activity>
            </div>
          </ng-template>
        </li>

        <li [ngbNavItem]="'annexes'" [disabled]="!entity?.id">
          <a ngbNavLink appDwNavLink (click)="fetchAnnexes()">
            <i class="digi-out-text-file me-2 text-primary position-relative">
              <dw-ui-counter [value]="annexesCount"></dw-ui-counter>
            </i>
            {{ 'Doc::Annexes' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <core-annexes-list
                [canDownload]="true"
                [canUpload]="true"
                [canDelete]="true"
                [canPreview]="true"
                [canEdit]="true"
                [folderName]="'quote-detail/' + entity?.id"
                [annexes]="annexesAsPromise$ | async"
                (createOrUpdateAnnexes)="createOrUpdateAnnexes($event)"
                (deleteAnnex)="deleteAnnex($event)"
                (deleteAnnexes)="deleteAnnexes($event)"
              ></core-annexes-list>
            </div>
          </ng-template>
        </li>

        <li [ngbNavItem]="'documents'" [disabled]="!entity?.id">
          <a ngbNavLink appDwNavLink>
            <i class="me-2 text-primary" class="digi-out-annex me-2"></i
            >{{ 'Doc::Documents' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <document-all-documents-with-projects-list
              [customerProjectDisplayNumber]="this.entity?.displayNumber"
            ></document-all-documents-with-projects-list>
          </ng-template>
        </li>

        <li [ngbNavItem]="'docAnnexes'" [disabled]="!entity?.id">
          <a ngbNavLink appDwNavLink>
            <i class="me-2 text-primary" class="digi-out-annex me-2"></i
            >{{ 'Doc::DocAnnexes' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <document-customer-project-annexes-list [customerProjectId]="this.entity?.id">
            </document-customer-project-annexes-list>
          </ng-template>
        </li>
      </ul>
      @if (entity?.id) {
        <dw-ui-dropdown-menu [dropdownMenu]="actions()"></dw-ui-dropdown-menu>
      }
      @if (saveActionBtns().length == 1) {
        <button
          (click)="saveActionBtns()[0].action()"
          class="btn btn-primary"
          type="submit"
          form="generalForm"
          [disabled]="!form.dirty"
        >
          {{ saveActionBtns()[0].label }}
        </button>
      } @else if (saveActionBtns().length > 1) {
        <div ngbDropdown #dropdown="ngbDropdown">
          <button
            type="button"
            class="btn btn-primary text-white p-2 dropdown-toggle-with-caret"
            id="dropdowntoolbar"
            ngbDropdownToggle
          >
            {{ '::Save' | abpLocalization }}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownActions">
            @for (btn of saveActionBtns(); track $index) {
              <button
                ngbDropdownItem
                type="submit"
                (click)="btn.action()"
                form="generalForm"
                class="d-flex align-items-center gap-2"
                [disabled]="btn.disabled()"
              >
                {{ btn.label }}
              </button>
            }
          </div>
        </div>
      }
    </div>

    <div [ngbNavOutlet]="nav" class="tab-content"></div>
  </dw-grid-tabs>

  <div side-panel-content>
    <dw-ui-side-panel #info [contentTemplate]="bodyTotal">
      <ng-template #bodyTotal>
        <document-customer-project-side-panel
          [entity]="entity"
          [deliveryAddressForm]="thirdPartyDeliveryAddress()"
          [fileBlobUrl]="fileBlobUrl"
        ></document-customer-project-side-panel>
        <label for="note" class="form-label text-primary mt-3">{{
          'GoliathCore::Note' | abpLocalization
        }}</label>
        @if (entity != null) {
          <textarea
            name="note"
            class="flex-grow-1"
            resize="none"
            [(ngModel)]="entity.note"
            (input)="updateNote($event)"
          ></textarea>
        }
      </ng-template>
    </dw-ui-side-panel>
    <dw-ui-side-panel #history [contentTemplate]="bodyHistory">
      <ng-template #bodyHistory>
        <div class="history__container">
          <dw-core-history
            [entityId]="entity?.id"
            [entityName]="GoliathDocumentEntityNames.CustomerQuote.fullName"
          ></dw-core-history>
        </div>
      </ng-template>
    </dw-ui-side-panel>
    <dw-ui-side-panel class="side-panel--full" #chatPanel [contentTemplate]="bodyChat">
      <ng-template #bodyChat>
        <dw-core-chat
          [entityId]="entity?.id"
          [entityName]="GoliathDocumentEntityNames.CustomerQuote.shortName"
          [entityReference]="entity?.displayNumber"
        ></dw-core-chat>
      </ng-template>
    </dw-ui-side-panel>
  </div>
</dw-ui-panel>

<ng-template #report let-offcanvas>
  <dw-ui-dialog-box [title]="'Reporting::Report:ReportPdf'" [displayFooter]="false">
    <dw-report-viewer
      [reportName]="docRole"
      [dataId]="entity.id"
      [templateId]="printTemplateId"
      (pdfRequested)="downloadPdfReport()"
    ></dw-report-viewer>
  </dw-ui-dialog-box>
</ng-template>
